import React from 'react';
import PropTypes from 'prop-types';

import { IconDownload } from '$partials/icons';
import { Image } from '$partials/media';
import { useLocale } from '$contexts/locale.jsx';

const defaultImage = {
    src: '/images/default-x1.jpg',
    x2: '/images/default-x2.jpg',
};

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const MediaKitListingItem = ({
    file,
    image,
    title
}) => {
    if (!file) { return null; }

    const type = file.contentType ? file.contentType.match(/^(?:application|image)\/(\w+)/i)?.[1] : null;
    const size = file.size ? Math.round(file.size * 0.00001) / 10 : null;

    return (
        <div className='flex flex-wrap flex-col-reverse sm:flex-row md:justify-between py-40 sm:py-50'>
            <div className='flex flex-col md:flex-row-reverse md:justify-end w-full sm:w-4/6 md:w-8/12'>
                <div className='w-full md:w-[66.666%] px-10 sm:px-15'>
                    <h3 className='type-style-3 mb-15 md:mb-0'>
                        {title}
                    </h3>
                </div>

                <div className='flex flex-row md:flex-col-reverse items-center md:items-start w-full md:w-[22.222%] px-10 sm:px-15'>
                    <a
                        className='block float-right md:flex-grow'
                        href={file.url}
                        rel='noreferrer'
                        target='_blank'>
                        <IconDownload />
                    </a>

                    <div className='type-style-7 text-dark-grey uppercase ml-10 md:ml-0 md:mb-20 md:mt-[4px]'>
                        {`${type ? type : ''}${(type && size) ? ' — ' : ''}${size ? `${size} MB` : ''}`}
                    </div>
                </div>
            </div>

            <figure className='w-full sm:w-2/6 md:w-3/12 px-10 sm:px-15 mb-20 sm:mb-0'>
                <Image {...(image || defaultImage)} />
            </figure>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

const propTypes = {
    file: PropTypes.shape({
        contentType: PropTypes.string,
        size: PropTypes.number,
        url: PropTypes.string,
    }),
    image: PropTypes.object,
    title: PropTypes.string,
};

MediaKitListingItem.propTypes = propTypes;

export default MediaKitListingItem;
